import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserProfileMenuDialog from './ui/UserProfileMenuDialog';

const AdminNavbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [isUserMenuOpen, setIsUserMenuOpen] = React.useState(false);
  const [userMenuAnchor, setUserMenuAnchor] = React.useState<HTMLElement | null>(null);

  const adminMenuItems = [
    {
      title: '학교 관리',
      path: '/admin/school-management',
    },
    {
      title: '교사 승인 관리',
      path: '/admin/teacher-approval',
    },
    {
      title: '담임 교사 관리',
      path: '/admin/homeroom-teachers',
    },
    {
      title: '알림 관리',
      path: '/admin/notifications',
    },
    {
      title: '보안 관리',
      path: '/admin/security',
    },
    ...(currentUser?.role === 'superAdmin'
      ? [{ title: '계정 등급', path: '/admin/teacher-plans' }]
      : []),
  ];

  const handleUserClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setUserMenuAnchor(event.currentTarget);
    setIsUserMenuOpen(true);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '60px',
        backgroundColor: 'var(--Color-background-normal, white)',
        borderBottom: '1px solid var(--Color-line-normal, #F0F0F0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '1200px',
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxSizing: 'border-box'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              fontSize: '18px',
              fontWeight: 700,
              color: 'var(--Color-text-strong, #0D0D0D)',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/admin')}
          >
            MARU 관리자
          </div>
          <div
            style={{
              width: '1px',
              height: '20px',
              backgroundColor: 'var(--Color-line-normal, #F0F0F0)'
            }}
          />
          <button
            type="button"
            onClick={() => navigate('/')}
            style={{
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--Color-fill-hover, #F5F5F5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            홈
          </button>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {adminMenuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                type="button"
                onClick={() => navigate(item.path)}
                style={{
                  padding: '8px 14px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: isActive
                    ? 'var(--Color-fill-hover, #F5F5F5)'
                    : 'transparent',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  fontWeight: isActive ? 600 : 500,
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.backgroundColor = 'var(--Color-fill-hover, #F5F5F5)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {item.title}
              </button>
            );
          })}
        </div>

        {currentUser && (
          <button
            type="button"
            onClick={handleUserClick}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              border: '1px solid var(--Color-line-normal, #F0F0F0)',
              backgroundColor: 'var(--Color-background-normal, white)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              fontWeight: 600,
              color: 'var(--Color-text-strong, #0D0D0D)',
              cursor: 'pointer'
            }}
            aria-label="사용자 메뉴 열기"
          >
            {currentUser.name?.[0] || 'A'}
          </button>
        )}
      </div>

      <UserProfileMenuDialog
        isOpen={isUserMenuOpen}
        onClose={() => {
          setIsUserMenuOpen(false);
          setUserMenuAnchor(null);
        }}
        anchorElement={userMenuAnchor}
      />
    </div>
  );
};

export default AdminNavbar; 